import { WindowTitle } from "@saleor/components/WindowTitle";
import Moment from "moment";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import RemittanceComponent from "./views/RemittanceList";

const RemittanceList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substring(1));
  const params = {
    orderDate: Moment(new Date()).format("YYYY-MM-DD"),
    ...qs
  };
  return <RemittanceComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Remittance",
          description: "remittance settlement section"
        })}
      />
      <Routes>
        <Route path={""} element={<RemittanceList />} />
      </Routes>
    </>
  );
};

export default Component;
